import { Block, cloneBlock, Blocks } from 'factories/block';
import { createBlock } from './block';
import { flatten } from 'factories/utils';
import { createEditableBtn } from './interactions/editableBtn';

export const createBookmark = (): Block => {
  return createBlock(
    'Bookmark',
    [
      createBlock('Image', [], { props: {} }),
      createBlock('Text', [], {
        props: {
          // content: 'Would you like to return to where you left off?',
        },
      }),
      createEditableBtn({
        label: 'No',
      }),
      createEditableBtn({
        label: 'Yes',
      }),
    ],
    {
      props: {},
    }
  );
};

export const addBookmarkBlock = (
  block: Block,
  props = {}
): [Block, Blocks?] => {
  if (block.type === 'Module') {
    const bookmarkBlock = createBookmark();

    const bookmarkBlockRef = {
      id: bookmarkBlock.id,
      type: 'Ref',
    };

    const nextBlock = cloneBlock(block);
    (nextBlock.children as Block[]).push(bookmarkBlockRef);

    const [newBlocks] = flatten(bookmarkBlock);

    return [nextBlock, newBlocks];
  }
  return [block, undefined];
};
